<template>
    <v-col cols="12" class="WithdrawalPoints mt-0 pt-0">
        <v-row
                align="stretch"
                justify="space-around"
                class="pa-4 pt-0"
                style="height: 100%"
        >
            <v-col cols="12" >
                <v-card
                        class="pa-4 elevation-0 "
                        tile
                        height="100%"
                >
                    <h2 class="font-weight-medium">Puntos de Retiro <a href="#" class="text-decoration-none">Neocity Energía</a></h2>


                    <v-data-iterator
                            :items="items"
                            :items-per-page.sync="itemsPerPage"
                            hide-default-footer
                    >
                        <template v-slot:header>
                            <v-row class="caption align-center">
                               
                                <v-col class="d-flex align-center" cols="6" lg="5">
                                   <p class="mb-0 mr-6">Estas Administrando</p> 
                                    <v-select
                                            :items="['Neocity Energía', 'Neocity', 'Colun', 'Nestle']"
                                            filled
                                            label="Estás Administrando"
                                            background-color="#0172C0"
                                            value="Neocity Energía"
                                            dark
                                            class="select-filter"
                                    ></v-select>
                                </v-col>
                             
                               <v-spacer></v-spacer>
                                <v-col class="justify-end" cols="6" lg="2">
                                      <v-text-field
                                                class="buscador tipo1"
                                                placeholder="Buscar en"
                                                outlined
                                                append-icon="mdi-magnify"
                                            v-model="search"

                                        ></v-text-field>
                                </v-col>
                              
                            </v-row>

                        </template>
                        <template v-slot:default="props">
                            <v-row class="justify-center">
                                <div >
                                    <v-card :key="'card-offers-add'"
                                            class="outline-0 py-12 card-max-width px-3 text-center overflow-hidden rounded-xl"
                                            @click="showDialog('Crear')"
                                            color="#fff" min-height="515px">
                                        <v-row class="py-12">
                                            <v-col>
                                                <v-icon size="80">mdi-plus</v-icon>
                                            </v-col>
                                        </v-row>
                                        <v-row>
                                            <v-col>
                                                <a href="#" class="">Agregar Nuevo Punto</a>
                                            <v-btn
                                            class="mt-6"
                                         @click.stop="$refs.uploadFile.dialog.show = true"
                                           color="green"
                                           outlined
                                           
                                            ><v-icon>mdi-microsoft-excel</v-icon> Carga Masiva CSV</v-btn>
                                            </v-col>
                                        </v-row>
                                    </v-card>
                                </div>
                                <div
                                        v-for="(item,key) in props.items"
                                        :key="item.name"
                                      
                                        @click="showDialog('Editar')"
                                >
                                    <v-card :key="'card-offers-'+key"
                                            class="outline-0 card-max-width py-6 px-3 text-center overflow-hidden rounded-xl"
                                            color="#fff">

                                        <v-img
                                                class="mx-auto"
                                                max-width="70%"
                                                alt="Neocity Logo"
                                                src="@/assets/images/neocity-logo.png"
                                                contain
                                        ></v-img>
                                        <v-col class="mx-auto" cols="12">
                                            <b class="text-left">
                                                Supermercado Mayor Calama Polpaico 220kv
                                            </b>
                                            <v-row class="text-left">
                                                <v-col>
                                                    Energia Anual
                                                </v-col>
                                                <v-col>
                                                    660kv
                                                </v-col>
                                            </v-row>
                                             <v-row class="text-left">
                                                <v-col>
                                                    Potencia
                                                </v-col>
                                                <v-col>
                                                    120
                                                </v-col>
                                            </v-row>
                                             <v-row class="text-left">
                                                <v-col>
                                                    Ubicacion
                                                </v-col>
                                                <v-col>
                                                    Av. las industrias 12354, comuna
                                                </v-col>
                                            </v-row>
                                             <v-row class="text-left">
                                                <v-col>
                                                    Contrato
                                                </v-col>
                                                <v-col>
                                                    10-03-20<br>
                                                    10-06-20
                                                </v-col>
                                            </v-row>
                                        </v-col>

                                        
                                       

                                       
                                        <v-divider></v-divider>
                                        <div class="pt-6" @click.stop >
                                            <v-btn class="px-1"  text small color="primary">Editar</v-btn>
                                            <v-btn class="px-1"  text small color="primary">Eliminar</v-btn>
                                            <v-btn  class="px-1" text small color="green">Validar <v-checkbox color="green"></v-checkbox></v-btn>
                                            
                                        </div>

                                    </v-card>

                                </div>
                            </v-row>
                        </template>

                        <template v-slot:footer>
                            <v-row class="mt-2" align="center" justify="center">
                                <span class="grey--text">Puntos por pagina</span>
                                <v-menu offset-y>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                                dark
                                                text
                                                color="primary"
                                                class="ml-2"
                                                v-bind="attrs"
                                                v-on="on"
                                        >
                                            {{ itemsPerPage }}
                                            <v-icon>mdi-chevron-down</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-list>
                                        <v-list-item
                                                v-for="(number, index) in itemsPerPageArray"
                                                :key="index"
                                                @click="updateItemsPerPage(number)"
                                        >
                                            <v-list-item-title>{{ number }}</v-list-item-title>
                                        </v-list-item>
                                    </v-list>
                                </v-menu>

                                <v-spacer></v-spacer>

                                <span
                                        class="mr-4
                                    grey--text"
                                >
                                    Pagina {{ page }} de {{ numberOfPages }}
                                  </span>
                                <v-btn
                                        fab
                                        x-small
                                        dark
                                        color="blue darken-3"
                                        class="mr-1"
                                        @click="formerPage"
                                >
                                    <v-icon>mdi-chevron-left</v-icon>
                                </v-btn>
                                <v-btn
                                        fab
                                        x-small
                                        dark
                                        color="blue darken-3"
                                        class="ml-1"
                                        @click="nextPage"
                                >
                                    <v-icon>mdi-chevron-right</v-icon>
                                </v-btn>
                            </v-row>
                        </template>
                    </v-data-iterator>

                </v-card>
            </v-col>
        </v-row>

        <v-dialog
                v-model="dialog.show"
                width="724"
        >
            <v-card class="pt-2 pa-8">
                <v-card-title class="headline mx-auto justify-left">
                   {{dialog.title}} Puntos de Retiro
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="4">
                            <v-card
                                    class="pa-4 ma-0 shadow-1 rounded-lg"
                                    tile
                                    height="160px"
                                    width="160px"
                            >
                                <v-img src="@/assets/images/neocity-logo.png"
                                       height="140px"
                                       width="140px"
                                       aspect-ratio="2"
                                       contain>
                                </v-img>
                            </v-card>
                        </v-col>
                        <v-col cols="8" class="pt-12">
                            <p>Neocity Energía</p>
                            <h3>76.222.222-7</h3>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Nombre del punto de retiro</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="Nombre del punto"
                                    dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Potencia</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="220KV"
                                    dense

                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Energía Anual</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="660KV"
                                    dense

                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Direccion del Punto de Reito
                            </v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="Calle #000, Comuna, Region, Pais"
                                    dense

                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1" style="height: 27px; ">Fecha de Inicio Contrato</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="01 - 05 -2020"
                                    dense
                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="px-3">
                        <v-col class="pa-0" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 border-bottom-1 " style="height: 27px; ">Periodo de contrato</v-subheader>
                        </v-col>
                        <v-col class="pa-0" cols="8">
                            <v-text-field
                                    placeholder="1 Año"
                                    dense

                            ></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mb-5 px-3 pb-3">
                        <v-col class="pa-0 border-bottom-1" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 " style="height: 27px; ">Bloque</v-subheader>
                        </v-col>
                        <v-col class="pa-0 border-bottom-1" cols="8">
                            <div class="mx-auto d-inline-flex">
                            <v-checkbox dense hide-details value="1">
                                <template v-slot:label>
                                    <v-chip
                                                class="ma-2"
                                                color="#004E85"
                                                label
                                                text-color="white"
                                        >
                                        A
                                    </v-chip>
                                </template>
                            </v-checkbox>
                                
                                <v-checkbox dense hide-details value="1">
                                    <template v-slot:label>
                                        <v-chip
                                            class="ma-2"
                                            color="#FF9A1B"
                                            label
                                            text-color="white"
                                        >
                                            B
                                        </v-chip>
                                    </template>
                                </v-checkbox>
                               
                                <v-checkbox dense hide-details value="1">
                                    <template v-slot:label>
                                        <v-chip
                                            class="ma-2"
                                            color="#0172C0"
                                            label
                                            text-color="white"
                                        >
                                            C
                                        </v-chip>
                                    </template>
                                </v-checkbox>
                               
                            </div>
                        </v-col>
                    </v-row>
                    <v-row class="px-3 ">
                        <v-col class="pa-0 border-bottom-1" cols="4">
                            <v-subheader class="font-weight-bold caption px-3 " style="height: 27px; ">Consideraciones</v-subheader>
                        </v-col>
                        <v-col class="pa-0 border-bottom-1" cols="8">
                            <v-textarea
                                    name="input-7-1"
                                    value="Ingrese aquí especificaciones"
                            ></v-textarea>

                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-btn
                            color="primary"
                            raised
                            outlined
                            @click="dialog.show = false"
                            class="pa-4"

                    >
                        Editar
                    </v-btn>
                    <v-btn
                            color="primary"
                            raised
                            dark
                            @click="dialog.show = false"
                            class="pa-4"
                    >
                        Cerrar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <upload-file-component :titleDialog="'Cargar Puntos de Retiro'" :formatFile="'csv'" ref="uploadFile"></upload-file-component>
    </v-col>
</template>

<script>
  import UploadFileComponent from '@/components/system/UploadFileComponent.vue';

    export default {
        name: 'WithdrawalPoints',
         components: {
            UploadFileComponent
        },
        data: () => ({
            dialog:{
                show:false,
                title:'',
            },
            itemsPerPageArray: [2,4, 8, 12],
            search: '',
            filter: {},
            sortDesc: false,
            page: 1,
            itemsPerPage: 4,
            items: [
                {
                    name: 'NEOCITY ENERGÍA',
                    rut: '76.859.223-7'
                },
                {
                    name: 'NEOCITY ENERGÍA',
                    rut: '76.859.223-7'

                },
                {
                    name: 'NEOCITY ENERGÍA',
                    rut: '76.859.223-7'

                },
                {
                    name: 'NEOCITY ENERGÍA',
                    rut: '76.859.223-7'

                },
            ],
        }),
        computed: {
            numberOfPages () {
                return Math.ceil(this.items.length / this.itemsPerPage)
            },
            filteredKeys () {
                return this.keys.filter(key => key !== `Name`)
            },
        },
        methods: {
            showDialog(type){
                this.dialog.show = true;
                this.dialog.title = type;
            },
            nextPage () {
                if (this.page + 1 <= this.numberOfPages) this.page += 1
            },
            formerPage () {
                if (this.page - 1 >= 1) this.page -= 1
            },
            updateItemsPerPage (number) {
                this.itemsPerPage = number
            },
        },
         created: function () {
            this.$emit('SetcolorMenu', '#FE9A00');
        }
    }
</script>